import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";

import { setSection, updateSection } from "../../../assignmentSlice";

import ScrambleButton from "../../widgets/ScrambleButton";

const ScramblePage = ({
  pageList,
  currentPage,
  currentIndex,
  setCurrentIndex,
  setPageList,
  setOverlayVisible,
}) => {
  const dispatch = useDispatch();
  const { section } = useSelector((state) => state.assignment);
  const [wordList, setWordList] = useState([]);

  useEffect(() => {
    if (currentPage.data.question) {
      setWordList(
        currentPage.data.question
          .filter((element) => element.type === "scramble")
          .map((element) => element.content)[0]
      );
    }
  }, [currentIndex]);

  const handleClickWord = (word) => {
    if (currentPage.isSubmitted) return;
    const newPageList = pageList.map((prevPage, index) => {
      if (index === currentIndex) {
        return {
          ...prevPage,
          data: {
            ...prevPage.data,
            question: prevPage.data.question.map((element) => {
              if (element.type === "scramble") {
                return {
                  ...element,
                  // 같은 단어인지는 번호로 본다. 저장된 답을 다시 불러오면 객체가 새로 만들어져서
                  // 참조로 비교하면 고른 단어를 눌러도 빠지지 않고 하나 더 붙는다
                  input: element.input.some((input) => input.index === word.index)
                    ? element.input.filter((input) => input.index !== word.index)
                    : [...element.input, word],
                };
              }
              return element;
            }),
          },
        };
      }
      return prevPage;
    });
    setPageList(newPageList);
    dispatch(setSection({ ...section, answer: newPageList }));
  };

  const handleSubmit = () => {
    if (currentPage.isSubmitted) return;

    const submitCount = currentPage.submitCount + 1;

    const scrambleElement = currentPage.data.question.find(
      (element) => element.type === "scramble"
    );

    let isCorrect = false;
    let newPageList = [];

    if (submitCount < 10) {
      isCorrect =
        scrambleElement.input.map((input) => input.text).join(" ") ===
        currentPage.data.answer;

      newPageList = pageList.map((prevPage, index) => {
        if (index === currentIndex) {
          return {
            ...prevPage,
            data: {
              ...prevPage.data,
              question: prevPage.data.question.map((element) => {
                if (element.type === "scramble") {
                  if (isCorrect) {
                    return element;
                  } else {
                    return {
                      ...element,
                      input: [],
                    };
                  }
                }
                return element;
              }),
            },
            isSubmitted: isCorrect,
            submitCount: submitCount,
          };
        }
        return prevPage;
      });
    } else {
      newPageList = pageList.map((prevPage, index) => {
        if (index === currentIndex) {
          return {
            ...prevPage,
            data: {
              ...prevPage.data,
              question: prevPage.data.question.map((element) => {
                if (element.type === "scramble") {
                  return {
                    ...element,
                    input: currentPage.data.answer.split(" ").map((word) => {
                      return { text: word };
                    }),
                  };
                }
                return element;
              }),
            },
            isSubmitted: true,
            submitCount: submitCount,
          };
        }
        return prevPage;
      });
    }
    setPageList(newPageList);
    dispatch(setSection({ ...section, answer: newPageList }));
    dispatch(
      updateSection({ sectionId: section.id, data: { answer: newPageList } })
    );

    if (submitCount < 10) {
      setOverlayVisible(true);
      setTimeout(() => {
        setOverlayVisible(false);
        if (isCorrect && currentIndex < pageList.length - 1) {
          setTimeout(() => {
            setCurrentIndex(currentIndex + 1);
          }, 200);
        }
      }, 600);
    } else {
      alert(
        "제출 횟수를 초과하였습니다. 정답을 확인하고, 다음 문제로 넘어가세요."
      );
    }
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "20px",
      }}
    >
      <div style={{ fontSize: Math.min(window.innerWidth, window.screen.width) <= 768 ? "14px" : "20px", fontWeight: 700, textAlign: "center" }}>영어 문장을 바탕으로 문장을 완성하세요.</div>
      <div
        style={{
          fontSize: Math.min(window.innerWidth, window.screen.width) <= 768 ? "17px" : "28px",
          textAlign: "center", // [v8] 문장 가운데
        }}
      >
        {currentPage.data.question && (
          <div style={{ wordBreak: "break-word", display: "inline" }}>
            {currentPage.data.question
              .map((element) => {
                if (element.type === "scramble") {
                  const blankLength = element.length;
                  const userAnswer = element.input;

                  return userAnswer
                    .map((answer) => answer.text)
                    .join(" ")
                    .concat(" ")
                    .padEnd(blankLength, "_");
                } else {
                  return element.content;
                }
              })
              .join(" ")}
          </div>
        )}
      </div>
      <div style={{ fontSize: Math.min(window.innerWidth, window.screen.width) <= 768 ? "14px" : "20px", color: "#7A8490" }}>
        {currentPage.data.kor}
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          gap: "30px",
        }}
      >
        {wordList.length > 0 && (
          <ScrambleButton
            wordList={wordList.slice(0, Math.ceil(wordList.length) / 2)}
            currentPage={currentPage}
            handleClickWord={handleClickWord}
            type={"analysis"}
          />
        )}
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          gap: "30px",
        }}
      >
        {wordList.length > 0 && (
          <ScrambleButton
            wordList={wordList.slice(Math.ceil(wordList.length) / 2)}
            currentPage={currentPage}
            handleClickWord={handleClickWord}
            type={"analysis"}
            key={2}
          />
        )}
      </div>
      <button
        style={{
          // [제출 인라인] 모바일은 흐름 속 배치(둥둥 제거), PC는 기존 위치
          position: Math.min(window.innerWidth, window.screen.width) <= 768 ? "static" : "absolute",
          alignSelf: Math.min(window.innerWidth, window.screen.width) <= 768 ? "flex-end" : undefined,
          marginTop: Math.min(window.innerWidth, window.screen.width) <= 768 ? "18px" : 0,
          bottom: "90px", // 최하단으로부터 10px 떨어짐
          right: "60px", // 우측으로부터 10px 떨어짐
          padding: Math.min(window.innerWidth, window.screen.width) <= 768 ? "8px 22px" : "10px 32px", // [제출 v2]
          backgroundColor: currentPage.isSubmitted ? "#E6EDEC" : "#0E141B", // ECHO cur-submit
          color: currentPage.isSubmitted === true ? "#7A8490" : "white",
          border: "none",
          fontSize: Math.min(window.innerWidth, window.screen.width) <= 768 ? "14px" : "16px",
          fontWeight: 700,
          borderRadius: "999px",
          cursor: "pointer",
        }}
        onClick={() => handleSubmit()}
      >
        제출하기
      </button>
    </div>
  );
};

export default ScramblePage;
